"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LaExcelenciaEnSaludCapilar() {
  const eyebrow = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const lineOne = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const lineTwo = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const paragraph = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.1
  });
  const ctas = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="4811" id="la-excelencia-en-salud-capilar" className="relative min-h-screen w-full overflow-hidden bg-background text-foreground">
        {/* Subtle background texture */}
        <div className="pointer-events-none absolute inset-0 opacity-[0.04] mix-blend-multiply" style={{
      backgroundImage: "radial-gradient(var(--foreground) 1px, transparent 1px)",
      backgroundSize: "3px 3px"
    }} aria-hidden="true" />

        {/* Vertical decorative tag */}
        <div className="pointer-events-none absolute left-4 top-1/2 z-20 hidden -translate-y-1/2 lg:block">
          <span className="font-default text-[0.65rem] uppercase tracking-[0.3em] text-foreground/60" style={{
        writingMode: "vertical-rl",
        transform: "rotate(180deg)"
      }}>
            Scroll — Filosofía (01 / 06)
          </span>
        </div>

        <div className="relative mx-auto grid min-h-screen max-w-[1500px] grid-cols-1 items-center gap-10 px-6 pb-16 pt-28 sm:px-10 lg:grid-cols-12 lg:gap-10 lg:px-16 lg:pb-16 lg:pt-32">
          {/* Text column */}
          <div className="z-10 flex flex-col justify-center lg:col-span-5">
            <div ref={eyebrow.ref} className="transition-all duration-700 ease-out translate-y-0 opacity-100 ![margin:0px_0px_32px_0px]">
              <span className="font-default text-[0.7rem] font-bold uppercase tracking-[0.3em] text-primary">
                — MS Instituto Capilar —
              </span>
            </div>

            <h1 className="font-default font-medium leading-[0.95] tracking-tight text-foreground">
              <div className="overflow-hidden">
                <div ref={lineOne.ref} className="transition-all duration-1000 ease-out translate-y-0 !text-6xl" style={{
              fontSize: "clamp(3.5rem, 9vw, 8.5rem)"
            }}>
                  La excelencia en salud capilar
                </div>
              </div>
            </h1>

            <p ref={paragraph.ref} className={`mt-10 max-w-[32ch] font-default text-lg leading-relaxed text-foreground/80 transition-all delay-300 duration-1000 ease-out sm:text-xl ${paragraph.isVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`}>
              Medicina capilar de alta precisión. Resultados naturales, personalizados y tratados con el rigor clínico que tu bienestar merece.
            </p>

            <div ref={ctas.ref} className="flex flex-wrap items-center gap-6 transition-all delay-500 duration-1000 ease-out translate-y-0 opacity-100 ![margin:48px_0px_0px_0px]">
              <Button asChild size="lg" className="group h-12 bg-primary px-7 font-default text-base font-medium text-primary-foreground shadow-md transition-all hover:bg-secondary">
                <Link href="https://msinstitutocapilar.com/contacto/" newTab>
                  Solicitar consulta
                  <ArrowRight className="ml-1 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>

              <Link className="group inline-flex items-center gap-1 font-default text-base italic text-foreground underline-offset-4 transition-all hover:underline" href="https://msinstitutocapilar.com/dra-soto" newTab>
                Conoce a la Dra. Soto
                <span className="inline-block transition-transform group-hover:translate-x-1">
                  →
                </span>
              </Link>
            </div>
          </div>

          {/* Media column */}
          <div className="relative self-stretch lg:col-span-7">
            <div ref={image.ref} className={`relative h-[60vh] min-h-[420px] w-full overflow-hidden rounded-none shadow-2xl transition-all duration-[1400ms] ease-out lg:absolute lg:inset-y-0 lg:right-[-4rem] lg:h-full lg:w-[calc(100%+4rem)] ${image.isVisible ? "translate-x-0 opacity-100" : "translate-x-8 opacity-0"}`}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1701322/img/edited-3cc9cc.png" alt="La Dra. María del Carmen Soto en MS Instituto Capilar" loading="eager" decoding="async" className="h-full w-full object-cover object-[75%_center] sm:object-[70%_center] !m-0" />
              <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
            backgroundImage: "radial-gradient(var(--foreground) 1px, transparent 1px)",
            backgroundSize: "2px 2px"
          }} aria-hidden="true" />

              <div className="absolute bottom-6 left-6 right-6 flex items-end justify-between">
                <span className="font-default text-[0.65rem] uppercase tracking-[0.25em] text-white/90">
                  Medicina Capilar Avanzada
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>;
}